import styled from 'styled-components'

export const Root = styled.div`
  cursor: pointer;
`

export const DescriptionListWrapper = styled.div`
  ${({ theme }) => `
    margin-top: calc(${theme.space.mobile.tiny} + 3px); 
  `}
`
